// from https://github.com/g13n/ua.js/blob/master/src/ua.js
var userAgent = navigator.userAgent || '';
function detect(pattern) {
    return function () {
        return (pattern).test(userAgent);
    };
}
var UA = {
    isIOS: detect(/iphone|ipad|ipod/i),
    isAndroid: detect(/android/i),
    isPre: detect(/(com\.douban\.frodo\/[\d.]+[.\w]*(dev|debug|test))|(com\.douban\.frodo\.test)/i),
    // copy from rexxar-common@src/assets/js/Globals.
    isDoubanApp: detect(/com\.douban\.(frodo|movie)/),
};
export default UA;
//# sourceMappingURL=ua.js.map